import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppService } from '../../app.service';
import { IConfigService } from '../../config/iconfigservice';
import { BaseService } from '@Services/base.service';
import { ObservableService } from '@Services';
@Injectable()
export class Input1Service extends BaseService {
    publicApiBaseUrl: string;

    constructor(
        public appService: AppService,
        public httpClient: HttpClient,
        public configService: IConfigService,
        public observableService: ObservableService
    ) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    submitCallback(caseId: string, caseIntegrationQueueId: string, payload: any) {
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/case/${caseId}/integration/${caseIntegrationQueueId}/input1/processresponse`;

        return super.postData(url, payload);
    }
}
